import { useTranslation } from 'react-i18next';
export function GetOrderPaletInfoForOrderDetailInfoTable(BOMOut) {

    const { t } = useTranslation();

    const rows = [
        createData(t('N° of palets'), BOMOut),
        createData(t('Pieces per palet'), BOMOut.quantityOnCarrier),
        createData(t('To be created'), BOMOut.quantityToProduce),
        createData(t('Quality'), BOMOut.productMetaData)
    ];


    function createData(name, info) {
        if (name === t('N° of palets')) {
            info = Math.ceil(info.quantityToProduce / info.quantityOnCarrier)
        }

        if (name === t('Quality')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 2)
            info = info.MetaData[0].Quality
        }

        return { name, info };
    }

    return rows
}

export function GetOrderPaletInfoForOrderInfoTable(BOMOut) {

    const { t } = useTranslation();

    const rows = [
        createData(t('N° of palets'), BOMOut),
        createData(t('Pieces per palet'), BOMOut.quantityOnCarrier),
        createData(t('Pieces'), BOMOut.quantityToProduce)
    ];

    function createData(name, info) {
        if (name === t('N° of palets')) {
            info = Math.ceil(info.quantityToProduce / info.quantityOnCarrier)
        }


        return { name, info };
    }

    return rows
}

export function GetOrderArticleInfoForOrderDetailInfoTable(BOMOut) {
    const { t } = useTranslation();

    const rows = [
        createData(t('Article'), BOMOut.productName),
        createData(t('Description'), BOMOut.productDescription),
        createData(t('Dimensions'), BOMOut.productMetaData),
        createData(t('Color'), BOMOut.productMetaData)
    ];

    function createData(name, info) {

        if (name === t('Dimensions')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 1)
            info = info.MetaData[0].Width.Value + " x " + info.MetaData[0].Length.Value + " x " + info.MetaData[0].Thickness.Value
        }

        if (name === t('Color')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 2)
            info = info.MetaData[0].Color
        }

        return { name, info };
    }

    return rows
}

export function GetOrderArticleInfoForOrderInfoTable(BOMOut) {
    const { t } = useTranslation();

    const rows = [
        createData(t('Article'), BOMOut.productName),
        createData(t('Description'), BOMOut.productDescription),
        createData(t('Dimensions'), BOMOut.productMetaData)
    ];

    function createData(name, info) {

        if (name === t('Dimensions')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 1)
            info = info.MetaData[0].Width.Value + " x " + info.MetaData[0].Length.Value + " x " + info.MetaData[0].Thickness.Value
        }

        return { name, info };
    }

    return rows
}

export function getNumberOfPaletsProducedForOrder(productionOrder, props) {
    let piecesPerPallet = props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
    return Math.ceil((parseInt(productionOrder.progress) / piecesPerPallet))
}

export function getTotalNumberOfPaletsNeededForOrder(productionOrder, props) {
    let piecesPerPallet = props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
    return Math.ceil(parseInt(productionOrder.pieces) / piecesPerPallet)
}

export function getPiecesPerPaletForOrder(productionOrder, props) {
    return props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
}

export function haveSameBOMIn(productionOrder1, productionOrder2) {

    let array1 = []
    let array2 = []

    var i;
    for (i = 0; i < productionOrder1.bomIn.length; i++) {
        array1.push(productionOrder1.bomIn[i].productId)
    }

    var y;
    for (y = 0; y < productionOrder2.bomIn.length; y++) {
        array2.push(productionOrder2.bomIn[y].productId)
    }

    array1 = array1.sort((a, b) => a - b)
    array2 = array2.sort((a, b) => a - b)

    if(JSON.stringify(array1) === JSON.stringify(array2)){
        return true
    }
    else{
        return false
    }
}